import { all, call, put, select, takeLatest } from 'redux-saga/effects'
import { t } from '../../../../common/i18n'
import * as CatalogoListAction from './catalogoListActions'
import {
  catalogoListFailedAction,
  catalogoListOkAction,
} from './catalogoListActions'
import { CatalogResponse } from './types'
import { getCatalogData } from './catalogoListApi'
import { selectUserInfo } from '../../../../common/context/selectors/userSelectors'
import { selectCesta } from '../../../../common/context/selectors/cestaSelectors'
import { IAppState } from '../../../../common/context/context'
import {
  catalogoFilterValuesFailedAction,
  catalogoFilterValuesOkAction,
} from '../filter/catalogoFilterValuesAction'
import { selectCatalogoFilterValues } from '../filter/catalogoFilterValuesSelectors'
import { CatalogoFilters } from '../../type/filter'
import { adjustPrecioFilterWithEffectivePrices } from '../../filter/catalogProductEffectivePrice'
import { mergeFacetOptionsWithPrevious } from '../../filter/mergeFacetOptionsWithPrevious'
import { Producto } from '../../producto/producto'

export function* getCatalogoData<T>(
  action: ReturnType<typeof CatalogoListAction.catalogoListAction>
) {
  const { payload, meta } = action
  const { catalogKey } = meta

  try {
    const userInfo = yield select(selectUserInfo)
    const cesta = yield select((state: IAppState) => selectCesta(state))
    const cupones = cesta?.cupones ?? []

    const catalogoData: CatalogResponse<T> = yield call(
      getCatalogData,
      catalogKey,
      { ...payload, userInfo, cupones }
    )
    yield put(catalogoListOkAction<T>(catalogKey, catalogoData))

    if (catalogoData.availableFilters) {
      const prevFilters: CatalogoFilters | null = yield select(
        selectCatalogoFilterValues,
        catalogKey
      )

      const adjustedFilters = adjustPrecioFilterWithEffectivePrices(
        mergeFacetOptionsWithPrevious(
          prevFilters,
          catalogoData.availableFilters as CatalogoFilters
        ) as Record<string, unknown>,
        catalogoData.products as Producto[] | undefined
      ) as CatalogoFilters

      yield put(catalogoFilterValuesOkAction(catalogKey, adjustedFilters))
    } else if (
      (!catalogoData.products || catalogoData.products.length === 0)
    ) {
      // Si no hay resultados y el backend no devuelve availableFilters,
      // mantenemos la estructura anterior pero ponemos count=0.
      const prevFilters: CatalogoFilters | null = yield select(
        selectCatalogoFilterValues,
        catalogKey
      )

      if (prevFilters) {
        const zeroed: CatalogoFilters = Object.fromEntries(
          Object.entries(prevFilters).map(([k, f]: [string, any]) => {
            if (
              (f.type === 'enum' || f.type === 'boolean') &&
              Array.isArray(f.values)
            ) {
              return [
                k,
                {
                  ...f,
                  values: f.values.map((v: any) => ({
                    ...v,
                    count: 0,
                  })),
                },
              ]
            }
            return [k, f]
          })
        )

        yield put(catalogoFilterValuesOkAction(catalogKey, zeroed))
      }
    }
  } catch (err) {
    yield put(catalogoListFailedAction(catalogKey, t(`No hay ${catalogKey}`)))
    yield put(
      catalogoFilterValuesFailedAction(catalogKey, t(`No hay ${catalogKey}`))
    )
  }
}

function* sagas() {
  return all([
    yield takeLatest(CatalogoListAction.CATALOGO_LIST, getCatalogoData),
  ])
}

export default sagas
